(function () {
  if (window.SunefunCartGuardInstalled) return;

  var PRODUCT_ID = "9074072125659";
  var PRODUCT_HANDLES = ["sunefun-home-composter", "sunefun-food-recycler"];
  var guardQueue = Promise.resolve();
  var originalFetch = window.fetch && window.fetch.bind(window);

  if (!originalFetch || !isSunefunProductPage()) return;

  window.SunefunCartGuardInstalled = true;

  function isSunefunProductPage() {
    return (
      !!document.querySelector('[data-product-id="' + PRODUCT_ID + '"]') ||
      PRODUCT_HANDLES.some(function (handle) {
        return (
          window.location.pathname.indexOf("/products/" + handle) > -1 ||
          !!document.querySelector('[data-product-handle="' + handle + '"]')
        );
      })
    );
  }

  function getRoutesRoot() {
    if (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) return window.Shopify.routes.root;
    return "/";
  }

  function getProductId() {
    var form = document.querySelector('[data-product-id="' + PRODUCT_ID + '"]');
    if (form && form.dataset.productId) return String(form.dataset.productId);

    var handleForm = null;
    PRODUCT_HANDLES.some(function (handle) {
      handleForm = document.querySelector('[data-product-handle="' + handle + '"][data-product-id]');
      return !!handleForm;
    });

    if (handleForm && handleForm.dataset.productId) return String(handleForm.dataset.productId);
    if (window.MinimogSettings && window.MinimogSettings.productId) return String(window.MinimogSettings.productId);
    return PRODUCT_ID;
  }

  function isCartAddRequest(request) {
    if (!request || request.method.toUpperCase() !== "POST") return false;

    var url = new URL(request.url, window.location.origin);
    var isCartAdd = /\/cart\/add(\.js)?$/.test(url.pathname);

    return isCartAdd && url.searchParams.get("kaching_bundles") === "true";
  }

  async function readJsonBody(request) {
    var text = await request.clone().text();
    if (!text) return null;

    try {
      return JSON.parse(text);
    } catch (error) {
      return null;
    }
  }

  function parseKachingMeta(value) {
    if (!value) return null;
    if (typeof value === "object") return value;

    try {
      return JSON.parse(value);
    } catch (error) {
      return null;
    }
  }

  function getKachingMeta(item) {
    if (!item || !item.properties) return null;
    return parseKachingMeta(item.properties.__kaching_bundles || item.properties._kaching_bundles);
  }

  function getIncomingBundle(addPayload) {
    var items = addPayload && Array.isArray(addPayload.items) ? addPayload.items : [];
    var mainItem = null;
    var mainMeta = null;

    items.some(function (item) {
      var meta = getKachingMeta(item);
      if (meta && meta.main === true) {
        mainItem = item;
        mainMeta = meta;
        return true;
      }
      return false;
    });

    if (!mainItem || !mainMeta) return null;

    return {
      mainVariantId: String(mainItem.id),
      meta: mainMeta,
      productId: getProductId(),
    };
  }

  function sameBundleGroup(left, right) {
    if (!left || !right) return false;

    var keys = ["id", "deal", "bar"];
    var compared = 0;
    var matched = 0;

    keys.forEach(function (key) {
      if (left[key] === undefined || right[key] === undefined) return;
      compared += 1;
      if (String(left[key]) === String(right[key])) matched += 1;
    });

    return compared >= 2 && compared === matched;
  }

  function shouldRemoveCartItem(item, incomingBundle) {
    var meta = getKachingMeta(item);
    if (meta && meta.main !== true) return false;

    var productMatches = incomingBundle.productId && String(item.product_id) === incomingBundle.productId;
    var variantMatches = incomingBundle.mainVariantId && String(item.id) === incomingBundle.mainVariantId;
    var bundleMatches = meta && meta.main === true && sameBundleGroup(meta, incomingBundle.meta);

    return productMatches || variantMatches || bundleMatches;
  }

  async function fetchCart() {
    var response = await originalFetch(getRoutesRoot() + "cart.js", {
      headers: {
        Accept: "application/json",
      },
    });

    if (!response.ok) throw new Error("Unable to check cart before checkout.");
    return response.json();
  }

  async function removeExistingBundleLines(incomingBundle) {
    var cart = await fetchCart();
    var updates = {};

    (cart.items || []).forEach(function (item) {
      if (!shouldRemoveCartItem(item, incomingBundle)) return;
      updates[item.key || item.id] = 0;
    });

    if (Object.keys(updates).length === 0) return;

    var response = await originalFetch(getRoutesRoot() + "cart/update.js", {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ updates: updates }),
    });

    if (!response.ok) throw new Error("Unable to update cart before checkout.");
  }

  function showGuardError(error) {
    var message = error && error.message ? error.message : "Cart could not be prepared. Please try again.";
    var target = document.querySelector(".m-product-form-message") || document.body;

    if (window.MinimogTheme && window.MinimogTheme.Notification) {
      window.MinimogTheme.Notification.show({
        target: target,
        method: "appendChild",
        type: "error",
        message: message,
        last: 5000,
        sticky: target === document.body,
      });
    }

    console.error("[Sunefun cart guard]", error);
  }

  function guardFailureResponse(error) {
    showGuardError(error);

    return new Response(
      JSON.stringify({
        status: 422,
        message: "Cart Error",
        description: error && error.message ? error.message : "Cart could not be prepared. Please try again.",
      }),
      {
        status: 422,
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
  }

  async function guardedFetch(input, init) {
    var request = input instanceof Request ? input.clone() : new Request(input, init);

    if (!isCartAddRequest(request)) {
      return originalFetch(input, init);
    }

    var addPayload = await readJsonBody(request);
    var incomingBundle = getIncomingBundle(addPayload);

    if (!incomingBundle) {
      throw new Error("Unable to identify the selected bundle. Please refresh and try again.");
    }

    await removeExistingBundleLines(incomingBundle);

    return originalFetch(input, init);
  }

  window.fetch = function (input, init) {
    var request;

    try {
      request = input instanceof Request ? input.clone() : new Request(input, init);
    } catch (error) {
      return originalFetch(input, init);
    }

    if (!isCartAddRequest(request)) {
      return originalFetch(input, init);
    }

    guardQueue = guardQueue
      .catch(function () {})
      .then(function () {
        return guardedFetch(input, init);
      });

    return guardQueue.catch(guardFailureResponse);
  };
})();
